module.exports = __webpack_public_path__ + "static/media/mastercard.251b9ea7.svg";